import publishedCmsPages from '~~/public/cms-schemas/published-pages.json';
import type { LocalisedString } from '~~/helpers/seo/types/LocalisedString';
import { CMS_PAGE_LOCALE } from '~~/constants/regex';
import type { PublishedCmsPages } from '~~/helpers/cms/publishedCmsPages';

type CmsPageLookup = {
  languageAndCountry: string,
  pageSlug: string,
  publishedPages?: PublishedCmsPages,
};

export const buildLocalizedCmsPageList = ({
  languageAndCountry,
  pageSlug,
  publishedPages = publishedCmsPages,
}: CmsPageLookup): LocalisedString[] => {

  const currentPageGroupPrefix = getCmsPagePrefix({ languageAndCountry, pageSlug, publishedPages });

  if (!currentPageGroupPrefix) {

    return [];

  }

  const matchedKeys = Object.keys(publishedPages).filter(
    (key) => publishedPages[key] === currentPageGroupPrefix,
  );

  return matchedKeys.map((key) => {

    const localeMatch = key.match(CMS_PAGE_LOCALE);
    const locale = localeMatch?.[1] ?? '';
    const value = locale ? key.replace(`-${locale}`, '') : key;

    return {
      locale,
      value,
    };

  });

};

export const getCmsPagePrefix = ({
  languageAndCountry,
  pageSlug,
  publishedPages = publishedCmsPages,
}: CmsPageLookup): string | null => {

  const baseFileName = `${pageSlug}-${languageAndCountry}`;
  const currentPagePrefix = publishedPages[baseFileName];

  if (typeof currentPagePrefix === 'string') {

    return currentPagePrefix;

  }

  return null;

};
